export default __webpack_public_path__ + "static/media/niura200x200.fd2bcf01.png";